import React from 'react'
import { Typography, Button } from 'antd'
import { useTranslation } from 'react-i18next'
import { useModalStore } from '../../store/ModalStore'
import { MODAL_STATE } from '../../types/modals'
import './TournamentIntro.css'
import InstagramVideo from '../Home/Main/TryOut/InstagramVideo'

const { Title, Paragraph } = Typography

const TournamentIntro: React.FC = () => {
    const { t } = useTranslation()
    const { openModal } = useModalStore()

    const handleUpcomingCupsClick = () => {
        const element = document.getElementById('upcoming-cups')
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
    }

    const handleContactUsClick = () => {
        openModal(MODAL_STATE.CONTACT_US)
    }

    return (
        <div className="tournament-intro-container">
            <div className="tournament-intro-content">
                {/* Left - Text and Buttons */}
                <div className="text-container">
                    <Title className="title" level={2}>
                        {t('tournaments.intro.title')}
                    </Title>

                    <Paragraph className="paragraph">
                        {t('tournaments.intro.description')}
                    </Paragraph>

                    <div className="buttons-container">
                        <Button
                            type="primary"
                            size="large"
                            className="upcoming-cups-btn"
                            onClick={handleUpcomingCupsClick}
                        >
                            {t('tournaments.intro.upcomingCups')}
                        </Button>
                        <Button
                            type="primary"
                            size="large"
                            className="contact-us-btn"
                            onClick={handleContactUsClick}
                        >
                            {t('tournaments.intro.contactUs')}
                        </Button>
                    </div>
                </div>

                {/* Right - Instagram embed */}
                <div className="video-container">
                    <InstagramVideo videoUrl="/videos/winner_summer_cup_munich_2025.mp4" />
                </div>
            </div>
        </div>
    )
}

export default TournamentIntro
